<template>
  <v-layout align-center>
    <span class="indicator">
      <span
        class="indicator__value"
        :style="{ width: integerValue + '%' }"
      />
    </span>
    <span>{{ text }}</span>
  </v-layout>
</template>

<script>
import filters from '@/constants/filters';

export default {
    name: 'SimilarIndicator',
    filters: {
        ...filters
    },
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    computed: {
        text () {
            return (
                this.$options.filters.persent(this.integerValue) +
        ' ' +
        this.$t('alikes_families.similarity')
            );
        },
        integerValue () {
            return Math.trunc(this.value);
        }
    }
};
</script>

<style scoped></style>
